import React, { useCallback, useEffect, useMemo, useState } from 'react';
import HisAlertColumn from './HisAlertColumn';
import ApiGo_TS from '../../../../actions/ApiGo_TS';
import HisMobilityDayChart from './HisMobilityDayChart';
import { useAppSelector } from '../../../../stores/hooks';
import UiIntegrater from '../littleUIComponent/UiIntegrater';
import { useTranslation } from 'react-i18next';
import HisAlertColumnByDays from './HisAlertColumnByDays';
import { useDispatch } from 'react-redux';
import { ADD_RESPONSE } from '../../../../stores/reducer_add';
import { ADD_HIS_ALERTS } from '../../../../stores/reducer_HistoryData';
import HisAlertColumnByDays_all from './HisAlertColumnByDays_all';
import { AnyAaaaRecord } from 'dns';

interface NIBIF {
  NIB_acc: string;
  NIB_counts: string;
}
interface estimateIF extends NIBIF {
  past_fs_observation_times_per_hour: any[];
  past_fs_observation_values_per_hour: any[];
  regression_line: any[];
  startTime: string;
  time_interval_count?: TimeIntervalCount[];
  fsensor: FSensorData[];
}
interface residentIF {
  id: number;
  last_name: string;
  first_name: string;
}

interface TimeIntervalCount {
  leaveBedCountTimesArr: (number | null)[];
  lieDownCountTimesArr: (number | null)[];
  sitUpCountTimesArr: (number | null)[];
  turnOverCountTimesArr: (number | null)[];
}

interface MobilityData {
  past_fs_observation_times_per_hour: number[];
  past_fs_observation_values_per_hour: number[];
  time_interval_count: TimeIntervalCount;
}

interface TimeIntervalCount {
  start_datetime: string;
  end_datetime: string;
  mobility_type_id: number;
}

interface MobilityCountResult {
  sitUpCountDayTimesArr: number[];
  lieDownCountDayTimesArr: number[];
  leaveBedCountDayTimesArr: number[];
  turnOverCountDayTimesArr: number[];
  sitUpCountNightTimesArr: number[];
  lieDownCountNightTimesArr: number[];
  leaveBedCountNightTimesArr: number[];
  turnOverCountNightTimesArr: number[];
}
interface FSensorData {
  observation: number;
  created_at: string;
}

interface FSensorResult {
  fs_observation_times_all?: number[];
  fs_observation_values_all?: number[];
  fs_observation_times_day?: number[];
  fs_observation_values_day?: number[];
  fs_observation_times_night?: number[];
  fs_observation_values_night?: number[];
}

const HisMobilityByDays = ({ data, daySwitch }: any): React.JSX.Element => {
  let resident: residentIF = data;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // ------- redux --------------------
  const store_timestamp = useAppSelector((state) => state.store_historyData.timestamp);
  const [isLoading, setIsLoading] = useState(false);
  const [mobilityData, setMobilityData] = useState({
    fs_observation_times: [] as any[],
    fs_observation_values: [] as any[],
    time_interval_count: {} as any,
  });


  const fetchData = async () => {
    if (store_timestamp.length === 0) return;

    setIsLoading(true);
    try {
      const dateTime = convertDatestamp(store_timestamp);
      const { fromDate, endDate } = convertDatestamp(store_timestamp);

      const res = await ApiGo_TS.getMobilityEstimateForDays<estimateIF>(resident.id, dateTime);
      const result = calculateMobilityCount(res.time_interval_count || [], fromDate, endDate, daySwitch);
      const resultFsensor = calculateFSensorData(res.fsensor, fromDate, endDate, daySwitch);

      let observationTimes;
      let observationValues;

      switch (daySwitch) {
        case 'all':
          observationTimes = resultFsensor.fs_observation_times_all;
          observationValues = resultFsensor.fs_observation_values_all;
          break;
        case 'day':
          observationTimes = resultFsensor.fs_observation_times_day;
          observationValues = resultFsensor.fs_observation_values_day;
          break;
        case 'night':
          observationTimes = resultFsensor.fs_observation_times_night;
          observationValues = resultFsensor.fs_observation_values_night;
          break;
        default:
          observationTimes = resultFsensor.fs_observation_times_all;
          observationValues = resultFsensor.fs_observation_values_all;
      }

      setMobilityData({
        fs_observation_times: observationTimes || [],
        fs_observation_values: observationValues || [],
        time_interval_count: result,
      });
      if (isDataEmpty({ observationValues, result, daySwitch })) {
        dispatch(ADD_RESPONSE({ status: 404, statusText: 'Not Found', type: 'hisRec_no_data' }));
        dispatch(ADD_HIS_ALERTS([]));
        // return;
      }
      setIsLoading(false);
    } catch (error) {
      setMobilityData((prev) => ({ ...prev, estimate: 0 }));
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [store_timestamp, resident.id, daySwitch]);

  return (
    <div className="fx-d-c gap10 h-85">
      <div
          style={{
            opacity: isLoading ? 0 : 1,
            transition: 'opacity 0.2s ease-in-out',
            flex: 1,
          }}>
          {daySwitch === 'all' ? <HisAlertColumnByDays_all timesValuesData={mobilityData.fs_observation_times} observationValuesData={mobilityData.fs_observation_values} timeIntervalCount={mobilityData.time_interval_count} /> : <HisAlertColumnByDays timesValuesData={mobilityData.fs_observation_times} observationValuesData={mobilityData.fs_observation_values} timeIntervalCount={mobilityData.time_interval_count} daySwitch={daySwitch} />}
        </div>
    </div>
  );
};
export default HisMobilityByDays;

//轉換日期
export const convertDatestamp = (timestamp: any) => {
  const baseDate = new Date(timestamp);

  const fromDate = new Date(timestamp);
  fromDate.setDate(baseDate.getDate()-29);

  const endDate = new Date(timestamp);
  endDate.setDate(baseDate.getDate());

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return {
    fromDate: formatDate(fromDate),
    endDate: formatDate(endDate),
  };
};

//時間轉換API格式
export function convertTimestamp(timestamp: any) {
  const timestampDate = new Date(timestamp);
  const currentDate = new Date();

  const year = timestampDate.getFullYear();
  const month = String(timestampDate.getMonth() + 1).padStart(2, '0');
  const day = String(timestampDate.getDate()).padStart(2, '0');

  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

const isDataEmpty = ({ observationValues, result, daySwitch }: any): boolean => {
  const isArrayAllNull = (arr: (number | null)[]) => {
    if (!Array.isArray(arr) || arr.length === 0) return true;
    return arr.every((value) => value === null || value === 0);
  };

  const isTimeIntervalCountEmpty = (data: any, daySwitch: string) => {
    if (!data) return true;

    switch (daySwitch) {
      case 'day':
        return isArrayAllNull(data.sitUpCountDayTimesArr || []) && isArrayAllNull(data.lieDownCountDayTimesArr || []) && isArrayAllNull(data.leaveBedCountDayTimesArr || []) && isArrayAllNull(data.turnOverCountDayTimesArr || []);
      case 'night':
        return isArrayAllNull(data.sitUpCountNightTimesArr || []) && isArrayAllNull(data.lieDownCountNightTimesArr || []) && isArrayAllNull(data.leaveBedCountNightTimesArr || []) && isArrayAllNull(data.turnOverCountNightTimesArr || []);
      case 'all':
        return isArrayAllNull(data.sitUpCountDayTimesArr || []) && isArrayAllNull(data.lieDownCountDayTimesArr || []) && isArrayAllNull(data.leaveBedCountDayTimesArr || []) && isArrayAllNull(data.turnOverCountDayTimesArr || []) && isArrayAllNull(data.sitUpCountNightTimesArr || []) && isArrayAllNull(data.lieDownCountNightTimesArr || []) && isArrayAllNull(data.leaveBedCountNightTimesArr || []) && isArrayAllNull(data.turnOverCountNightTimesArr || []);
      default:
        return true;
    }
  };

  return isArrayAllNull(observationValues || []) && isTimeIntervalCountEmpty(result, daySwitch);
};

const calculateMobilityCount = (timeIntervalCount: TimeIntervalCount[], fromDate: string, endDate: string, daySwitch: string): MobilityCountResult => {
  const initialResult: MobilityCountResult = {
    sitUpCountDayTimesArr: Array(30).fill(0),
    lieDownCountDayTimesArr: Array(30).fill(0),
    leaveBedCountDayTimesArr: Array(30).fill(0),
    turnOverCountDayTimesArr: Array(30).fill(0),
    sitUpCountNightTimesArr: Array(30).fill(0),
    lieDownCountNightTimesArr: Array(30).fill(0),
    leaveBedCountNightTimesArr: Array(30).fill(0),
    turnOverCountNightTimesArr: Array(30).fill(0),
  };

  const baseDate = new Date(fromDate);
  baseDate.setHours(0, 0, 0, 0);

  // 根據時間獲取天數
  const getDayIndex = (date: Date): number => {
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);
    return Math.floor((targetDate.getTime() - baseDate.getTime()) / (24 * 60 * 60 * 1000));
  };

  const updateCount = (mobilityType: number, dayIndex: number, isDayTime: boolean) => {
    if (isDayTime) {
      switch (mobilityType) {
        case 411:
          initialResult.sitUpCountDayTimesArr[dayIndex]++;
          break;
        case 421:
          initialResult.lieDownCountDayTimesArr[dayIndex]++;
          break;
        case 431:
          initialResult.leaveBedCountDayTimesArr[dayIndex]++;
          break;
        case 441:
          initialResult.turnOverCountDayTimesArr[dayIndex]++;
          break;
      }
    } else {
      switch (mobilityType) {
        case 411:
          initialResult.sitUpCountNightTimesArr[dayIndex]++;
          break;
        case 421:
          initialResult.lieDownCountNightTimesArr[dayIndex]++;
          break;
        case 431:
          initialResult.leaveBedCountNightTimesArr[dayIndex]++;
          break;
        case 441:
          initialResult.turnOverCountNightTimesArr[dayIndex]++;
          break;
      }
    }
  };

  timeIntervalCount.forEach((interval) => {
    const startTime = new Date(interval.start_datetime);
    const endTime = new Date(interval.end_datetime);
    const startHours = startTime.getHours();
    const endHours = endTime.getHours();
    const dayIndex = getDayIndex(startTime);

    if (dayIndex >= 0 && dayIndex < 30) {
      // 日間記錄 8:00-20:00
      if (startHours >= 8 && startHours < 20 && endHours >= 8 && endHours < 20) {
        updateCount(interval.mobility_type_id, dayIndex, true);
      }
      // 夜間記錄
      else if ((startHours >= 20 || startHours < 8) && (endHours >= 20 || endHours < 8)) {
        const nightIndex = startHours >= 20 ? dayIndex : Math.max(0, dayIndex - 1);
        updateCount(interval.mobility_type_id, nightIndex, false);
      }
    }
  });

  const result: Partial<MobilityCountResult> = {};

  if (daySwitch === 'all' || daySwitch === 'day') {
    result.sitUpCountDayTimesArr = initialResult.sitUpCountDayTimesArr;
    result.lieDownCountDayTimesArr = initialResult.lieDownCountDayTimesArr;
    result.leaveBedCountDayTimesArr = initialResult.leaveBedCountDayTimesArr;
    result.turnOverCountDayTimesArr = initialResult.turnOverCountDayTimesArr;
  }

  if (daySwitch === 'all' || daySwitch === 'night') {
    result.sitUpCountNightTimesArr = initialResult.sitUpCountNightTimesArr;
    result.lieDownCountNightTimesArr = initialResult.lieDownCountNightTimesArr;
    result.leaveBedCountNightTimesArr = initialResult.leaveBedCountNightTimesArr;
    result.turnOverCountNightTimesArr = initialResult.turnOverCountNightTimesArr;
  }

  return result as MobilityCountResult;
};

const calculateFSensorData = (fsensorData: FSensorData[], fromDate: string, endDate: string, daySwitch: string): FSensorResult => {
  const initialResult = {
    fs_observation_times_day: Array(30).fill(0),
    fs_observation_values_day: Array(30).fill(0),
    fs_observation_times_night: Array(30).fill(0),
    fs_observation_values_night: Array(30).fill(0),
  };

  const baseDate = new Date(fromDate);
  baseDate.setHours(0, 0, 0, 0);

  const getDayIndex = (date: Date): number => {
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);
    return Math.floor((targetDate.getTime() - baseDate.getTime()) / (24 * 60 * 60 * 1000));
  };

  fsensorData.forEach((data) => {
    const observationTime = new Date(data.created_at);
    const hours = observationTime.getHours();
    const dayIndex = getDayIndex(observationTime);

    if (dayIndex >= 0 && dayIndex < 30) {
      // 日間記錄 (8:00-20:00)
      if (hours >= 8 && hours < 20) {
        initialResult.fs_observation_times_day[dayIndex]++;
        initialResult.fs_observation_values_day[dayIndex] += data.observation;
      }
      // 夜間記錄 (20:00-8:00)
      else {
        const nightIndex = hours >= 20 ? dayIndex : Math.max(0, dayIndex - 1);
        initialResult.fs_observation_times_night[nightIndex]++;
        initialResult.fs_observation_values_night[nightIndex] += data.observation;
      }
    }
  });

  const result: FSensorResult = {};

  if (daySwitch === 'all') {
    result.fs_observation_times_all = initialResult.fs_observation_times_day.map((day, index) => day + initialResult.fs_observation_times_night[index]);
    result.fs_observation_values_all = initialResult.fs_observation_values_day.map((day, index) => day + initialResult.fs_observation_values_night[index]);
  } else if (daySwitch === 'day') {
    result.fs_observation_times_day = initialResult.fs_observation_times_day;
    result.fs_observation_values_day = initialResult.fs_observation_values_day;
  } else if (daySwitch === 'night') {
    result.fs_observation_times_night = initialResult.fs_observation_times_night;
    result.fs_observation_values_night = initialResult.fs_observation_values_night;
  }

  return result;
};

